<template>
  <form
    @submit.prevent.stop="">
    <col-collapse-filter
      @opened="openCollapseFilter"
      :close-button="false"
      :more-filters-label="'criteriaTabEnabled'">
      <div
        v-if="openedModal"
        class="outside_multiselectmodal"
        @click="openedModal = ''"></div>
      <div class="is-padding">
        <ModalMultiselect
          :is-multiselect="false"
          :opened-modal="openedModal"
          :data-array="contactResearchList"
          :selected-array="searchDestination"
          position-y="top"
          button-width="48.5"
          modal-width="100"
          width-unit="%"
          display-name="Type de recherche"
          @open="openedModal = $event"
          @update="updateFilter($event)" />
        <ModalMultiselect
          :opened-modal="openedModal"
          :data-array="naturesList"
          :selected-array="searchNatures"
          position-y="top"
          button-width="48.5"
          modal-width="100"
          width-unit="%"
          display-name="Nature du bien"
          @open="openedModal = $event"
          @update="updateFilter($event)" />
        <div class="field">
          <div class="control">
            <multiselect
              id="quickvSearchStates"
              class="multiselect--option-ico"
              name="referent-user"
              v-model="searchStates"
              :options="statesByRegion"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              group-values="states"
              group-label="region"
              :group-select="true"
              :placeholder="''"
              :custom-label="v => `${v.label} (${v.value})`"
              track-by="value">
              <span
                slot="placeholder"
                class="multiselect__placeholder">Régions et départements</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <div class="field has-addons columns">
              <p class="control is-expanded column is-8">
                <multiselect
                  @search-change="handleCitySearch"
                  @open="!cityFilter.length ? getCityByName() : null"
                  v-model="searchLocation"
                  :custom-label="v => `${v.city_code} (${v.zip_code})`"
                  label="v"
                  track-by="pk"
                  class="multiselect--option-ico is-single_choice"
                  open-direction="bottom"
                  :multiple="true"
                  :options="searchQuery.length > 0 ? cityFilter : []"
                  :searchable="true"
                  :internal-search="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''"
                  :show-no-options="false">
                  <span slot="noResult">Oups! Aucune ville trouvée.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Ville</span>
                  <!-- <span
                    slot="selection"
                    class="multiselect__placeholder"
                    v-if="searchLocation && searchLocation.length">
                    <span>Villes ({{ searchLocation.length }})</span>
                  </span> -->
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </p>
              <p
                class="select control is-expanded column is-4"
                style="height: 100%">
                <select
                  :disabled="!filterLocation"
                  style="width: 100%"
                  v-model="searchDistance">
                  <option :value="1">
                    1
                  </option>
                  <option :value="5">
                    5
                  </option>
                  <option :value="10">
                    10
                  </option>
                  <option :value="20">
                    20
                  </option>
                  <option :value="30">
                    30
                  </option>
                  <option :value="40">
                    40
                  </option>
                  <option :value="50">
                    50
                  </option>
                  <option :value="100">
                    100
                  </option>
                </select>
                <!-- <v-input
                  id="searchDistance"
                  :name="'searchDistance'"
                  @input="val => { updateFilterDistance(val)}"
                  :model="searchDistance"
                  :disabled="!filterLocation"
                  :number="true"
                  :min="0"
                  :max="200"
                  input-type="number"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as=" "
                  :placeholder="'5 km'">
                </v-input> -->
              </p>
            </div>
          </div>
        </div>
      </div>
      <div slot="criteria">
        <div class="field">
          <div class="control">
            <div class="is-margin-top-xsmall is-margin-bottom-xsmall">
              <r-label
                :label="'Budget (€)'"
                :is-required="false"
                class="has-text-grey"></r-label>
              <div class="field has-addons columns">
                <p class="control is-expanded column is-6">
                  <v-input
                    id="budget_min"
                    :name="'budget_min'"
                    @input="val => { search.budget_min = val ; updateBudgetFilter }"
                    :model="search.budget_min"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    v-validate="'decimal:2'"
                    :placeholder="'Min'">
                  </v-input>
                </p>
                <p class="control is-expanded column is-6">
                  <v-input
                    id="budget_max"
                    :name="'budget_max'"
                    @input="val => { search.budget_max = val ; updateBudgetFilter }"
                    :model="search.budget_max"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    v-validate="'decimal:2'"
                    :placeholder="'Max'">
                  </v-input>
                </p>
              </div>
            </div>
            <div class="is-margin-top-xsmall is-margin-bottom-xsmall">
              <r-label
                :label="'Surface (m²)'"
                :is-required="false"
                class="has-text-grey"></r-label>
              <div class="field has-addons columns">
                <p class="control is-expanded column is-6">
                  <v-input
                    id="surface_min"
                    :name="'surface_min'"
                    @input="val => { search.surface_min = val }"
                    :model="search.surface_min"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    v-validate="'decimal:2'"
                    data-vv-as=" "
                    :placeholder="'Min'">
                  </v-input>
                </p>
                <p class="control is-expanded column is-6">
                  <v-input
                    id="surface_max"
                    :name="'surface_max'"
                    @input="val => { search.surface_max = val }"
                    :model="search.surface_max"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    v-validate="'decimal:2'"
                    data-vv-as=" "
                    :placeholder="'Max'">
                  </v-input>
                </p>
              </div>
            </div>
            <ModalMultiselect
              class="is-margin-top-small"
              key="type"
              :opened-modal="openedModal"
              :data-array="filteredTypesList"
              :selected-array="searchTypes"
              button-width="48.5"
              modal-width="100"
              width-unit="%"
              display-name="Type du bien"
              @open="openedModal = $event"
              @update="updateFilter($event)" />
          </div>
        </div>
      </div>
      <div slot="more-criteria">
        <div class="field">
          <div class="control">
            <ModalMultiselect
              class="is-margin-top-small"
              key="subtype"
              :opened-modal="openedModal"
              :data-array="filteredSubtypesList"
              :selected-array="searchSubtypes"
              button-width="48.5"
              modal-width="100"
              width-unit="%"
              display-name="Caractéristique du bien"
              @open="openedModal = $event"
              @update="updateFilter($event)" />
          </div>
        </div>
      </div>
    </col-collapse-filter>
  </form>
</template>

<script>
import { DefaultValues, FilterGetter } from '@/mixins'
import moment from 'moment'
import { debounce } from 'lodash'

const emptySearch = ({
  research_date: null,
  budget_min: null,
  budget_max: null,
  lot_natures: [],
  lot_types: [],
  lot_subtypes: [],
  destination: '',
  states: [],
  surface_min: null,
  surface_max: null
})

export default {
  name: 'ContactSearch',
  mixins: [DefaultValues, FilterGetter],
  props: {
    source: Object
  },
  data () {
    return {
      searchQuery: '',
      openedModal: '',
      openedCol: true,
      search: [],
      searchBudget: [],
      searchDestination: '',
      searchStates: [],
      searchLocation: [],
      searchDistance: 1,
      searchNatures: [],
      searchTypes: [],
      searchSubtypes: [],
      searchDate: null,
      filteredLotTypes: [
        { value: 'T1', label: 'T1' },
        { value: 'T2', label: 'T2' },
        { value: 'T3', label: 'T3' },
        { value: 'T4', label: 'T4' },
        { value: 'T5', label: 'T5' },
        { value: 'T6_plus', label: 'T6 et plus' }
      ],
      cityFilter: []
    }
  },
  computed: {
    s () {
      return this.search
    },
    canSumit () {
      return !!this.s.research_date && !!this.s.destination
    },
    filteredTypesList () {
      return this.typesList.filter((x) => this.searchNatures.some(r => x.show.includes(r)))
    },
    filteredSubtypesList () {
      return this.subtypesList.filter((x) => this.searchNatures.some(r => x.show.includes(r)))
    },
    filterLocation () {
      if (Array.isArray(this.searchLocation) && this.searchLocation.length > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    searchNatures (to) {
      // delete type if nature is not selected
      let enabledTypes = this.typesList.filter((x) => to.some(r => x.show.includes(r))).map(x => x.value)
      this.searchTypes = this.searchTypes.filter(type => enabledTypes.includes(type))
      // delete subtype if nature is not selected
      let enabledSubtypes = this.subtypesList.filter((x) => to.some(r => x.show.includes(r))).map(x => x.value)
      this.searchSubtypes = this.searchSubtypes.filter(subtype => enabledSubtypes.includes(subtype))
    }
  },
  created () {
    if (this.source) {
      this.search = Object.assign({}, this.source)
      this.searchDate = this.search.research_date ? moment(this.search.research_date).toDate() : moment().toDate()
      this.searchDestination = this.search.destination
      this.searchDistance = this.search.distance / 1000
      this.searchLocation = this.search.location
      this.searchBudget = [this.search.budget_min, this.search.budget_max]
      this.searchNatures = this.search.lot_natures
      this.searchTypes = this.search.lot_types
      this.searchSubtypes = this.search.lot_subtypes
      this.search.states.forEach(x => {
        let state = this.statesData.find(y => y.value === x)
        if (state) this.searchStates.push(state)
      })
    } else {
      this.search = { ...emptySearch }
      this.searchDate = this.search.research_date ? moment(this.search.research_date).toDate() : moment().toDate()
    }
    // this.updateSearchLotType([this.search.lot_types[0] || 1, this.search.lot_types[this.search.lot_types.length - 1] || 6])
  },
  mounted () {
    this.getCityByName()
  },
  methods: {
    handleCitySearch (query) {
      this.searchQuery = query
      this.getCityByName(query)
    },
    updateFilter ({ filter, array, isMultiselect }) {
      if (isMultiselect && !array) return
      if (!isMultiselect) {
        // TODO regarder à mettre "array" à la place de this.searchDestination en dur
        if (this.searchDestination === filter.value) this.searchDestination = null
        else this.searchDestination = filter.value
      } else {
        // check if filter is date_livraison
        if (Array.isArray(filter.value)) {
          filter.value.forEach(year => {
            let i = array.findIndex(x => x === year)
            if (i >= 0) array.splice(i, 1)
            else array.push(year)
          })
        } else {
          let i = array.findIndex(x => x === filter.value)
          if (i >= 0) array.splice(i, 1)
          else array.push(filter.value)
        }
      }
    },
    openCollapseFilter () {
      this.openedCol = !this.openedCol
    },
    updateBudgetFilter: debounce(function (e) {
      console.log(e)
      this.searchBudget = [e[0], e[1]]
    }),
    // Not used yet
    // updateSearchLotType: debounce(function (e) {
    //   let tmp = []
    //   if (!(!Array.isArray(e) || !e.length)) {
    //     let min = String(e[0]).match(/\d/)[0]
    //     let max = String(e[1]).match(/\d/)[0]
    //     if (String(max) === '6') {
    //       tmp.push('T6_plus')
    //       max = 5
    //     }
    //     if (min !== 1 && max !== 6) {
    //       for (let i = min; i <= max; i++) {
    //         tmp.push(`T${i}`)
    //         tmp.push(`T${i}_bis`)
    //         tmp.push(`T${i}_duplex`)
    //       }
    //     }
    //   }
    //   this.$set(this.s, 'lot_types', tmp.sort())
    //   let type = tmp.sort().map(t => {
    //     if (t) return t.split('').find(x => x.match(/\d/))
    //   })
    //   this.searchLotTypes = [type[0], type[type.length - 1]]
    // }, 200),
    submitQuickview () {
      this.s.destination = this.searchDestination
      this.s.research_date = this.searchDate
      if (!this.canSumit) return this.$toasted.global.danger('Veuillez renseigner le type de recherche')
      if ((this.s.surface_min && this.hasMoreThanTwoDecimals(this.s.surface_min)) || (this.s.surface_max && this.hasMoreThanTwoDecimals(this.s.surface_max))) {
        return this.$toasted.global.danger('Surface : Veuillez renseigner 2 décimales maximum.')
      }
      if ((this.s.budget_min && this.hasMoreThanTwoDecimals(this.s.budget_min)) || (this.s.budget_max && this.hasMoreThanTwoDecimals(this.s.budget_max))) {
        return this.$toasted.global.danger('Budget : Veuillez renseigner 2 décimales maximum.')
      }
      if (this.search.budget_min) this.s.budget_min = this.search.budget_min
      else this.s.budget_min = 0
      if (this.search.budget_max) this.s.budget_max = this.search.budget_max
      // else delete this.s.budget_max
      if (!this.search.budget_max) this.s.budget_max = null
      if (this.searchLocation && this.searchLocation.length > 0) {
        this.s.location = this.searchLocation.map(item => {
          if (typeof item === 'object' && item !== null && item.pk) {
            return item.pk
          }
          return item
        })
        if (this.searchDistance) {
          this.s.distance = this.searchDistance
          this.s.distance = this.s.distance * 1000
        } else {
          // valeur par defaut si pas de valeur renseigner (5km)
          this.s.distance = 5 * 1000
        }
      } else {
        this.s.location = []
        this.s.distance = null
      }
      this.s.lot_natures = this.searchNatures
      this.s.lot_types = this.searchTypes
      this.s.lot_subtypes = this.searchSubtypes
      this.s.states = this.searchStates.map(x => x.value)
      this.s.surface_min = this.search.surface_min
      this.s.surface_max = this.search.surface_max
      // this.s.lot_types = this.searchLotTypes.map(x => x.value)
      this.s.research_date = moment(this.searchDate).hour(12).toISOString()
      this.$emit('submitQuickview', { search: this.s })
    },
    hasMoreThanTwoDecimals (num) {
      const numberAsString = num.toString()
      const dotIndex = numberAsString.indexOf('.')
      if (dotIndex === -1) return false
      const decimalPartLength = numberAsString.length - dotIndex - 1
      return decimalPartLength > 2
    }
    // updateFilterDistance (val) {
    //   if (val < 200) {
    //     this.searchDistance = val
    //   } else if (val === 200 || val > 200) {
    //     this.searchDistance = 200
    //   }
    // }
  }
}
</script>

<style lang="sass">
.outside_multiselectmodal
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: #FFFFFF
  opacity: 0.7
  z-index: 10
</style>
